import { getFrontendLogo } from "@/lib/helpers";
import Image from "next/image";
import Link from "next/link";

export const Logo = ({ className = "", style }) => {
  return (
    <Link href="/" className={`${className}`} style={style}>
      <Image
        src="https://res.cloudinary.com/dpkn1ppzj/image/upload/v1752688122/Frame_5_1_xkvii5.png"
        width={275}
        height={48}
        alt="Logo"
        priority
      />
    </Link>
  );
};
